import type { PhoneApp } from '../app/phone.js';
import { PhoneView } from './PhoneView.js';
import { RelaunchCard, SupersededCard } from './cards.js';

export function BootView({ status }: { status: string }) {
  return (
    <div class="app">
      <main class="main">
        <section class="card" role="status" data-testid="boot">
          <div class="who">CommsChannel Phone</div>
          <div class="sub">{status}</div>
        </section>
      </main>
    </div>
  );
}

export function RelaunchView({ reason }: { reason: string | null }) {
  return (
    <div class="app">
      <main class="main">
        <RelaunchCard reason={reason} />
      </main>
    </div>
  );
}

export function App({ app }: { app: PhoneApp }) {
  const phase = app.phase.value;
  if (phase === 'booting') return <BootView status="Starting…" />;
  if (phase === 'superseded')
    return (
      <div class="app">
        <main class="main">
          <SupersededCard app={app} />
        </main>
      </div>
    );
  if (phase === 'relaunch') return <RelaunchView reason={app.relaunchReason.value} />;
  return <PhoneView app={app} />;
}
